import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { UsuarioLogado } from 'src/app/core/models/usuario-logado.model';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  sidebarVisible: boolean = false;
  menusUser: MenuItem[] | undefined;
  menus: MenuItem[];
  usuario: UsuarioLogado | undefined;
  imagemLogoBase64: string;
  version: string;

  constructor(
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.version = environment.appVersion;

    this.usuario = this.authenticationService.obterUsuarioLogado;
    this.imagemLogoBase64 = this.authenticationService.obterEmpresa?.logo_laboratorio;
    localStorage.setItem('weblab_logo_lab', this.imagemLogoBase64);

    this.menusUser = [
      {
        label: this.usuario?.nome,
      },
      {
        label: this.usuario?.email,
      },
      {
        label: 'Alterar senha',
        icon: 'pi pi-user',
        routerLink: '/oticomlab/atualizar-senha'
      },
      {
        label: 'Sair',
        icon: 'pi pi-power-off',
        command: (event) => {
          this.authenticationService.logout();
        }
      }
    ];

    this.menus = [
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        routerLink: '/oticomlab/dashboard',
        command: (event) => {
          this.clickMenu(event);
        }
      },
      {
        label: 'Meus pedidos',
        icon: 'pi pi-fw pi-list',
        routerLink: '/oticomlab/pedidos',
        command: (event) => {
          this.clickMenu(event);
        }
      },
      {
        label: 'Novo pedido',
        icon: 'pi pi-fw pi-plus',
        items: [
          {
            label: 'Laboratório',
            icon: 'pi pi-shopping-cart',
            tooltip: 'Pedido com receita',
            routerLink: '/oticomlab/pedido-laboratorio',
            command: (event) => {
              this.clickMenu(event);
            }
          },
          {
            label: 'Atacado',
            icon: 'pi pi-cart-plus',
            tooltip: 'Pedido sem receita',
            routerLink: '/oticomlab/pedido-atacado',
            command: (event) => {
              this.clickMenu(event);
            }
          }
        ]
      },
      {
        label: 'Ajuda',
        icon: 'pi pi-fw pi-question',
        items: [
          {
            label: 'Fale Conosco',
            icon: 'pi pi-fw pi-whatsapp',
            url: `https://wa.me/55${this.authenticationService.obterEmpresa?.celular_whatsapp_laboratorio}`,
            command: (event) => {
              this.clickMenu(event);
            }
          },
          {
            label: 'Laboratório',
            icon: 'pi pi-fw pi-globe',
            url: `http://${this.authenticationService.obterEmpresa?.site_laboratorio}`,
            command: (event) => {
              this.clickMenu(event);
            }
          },
          {
            label: 'ÓTICOM LAB',
            icon: 'pi pi-fw pi-oticom',
            url: 'https://oticom.com.br/',
            command: (event) => {
              this.clickMenu(event);
            }
          },
          {
            label: 'Copyright EMBRATI',
            icon: 'pi pi-fw pi-copyright',
            url: `https://embrati.inf.br/`,
            command: (event) => {
              this.clickMenu(event);
            }
          },
        ]
      }
    ]
  }

  clickMenu($event: any) {
    this.sidebarVisible = !this.sidebarVisible;
  }
}
